'use client';

import React from 'react';
import { ProgressBar } from '../ProgressBar';
import { cn } from '../../utils/cn';

export interface ProgressBarWrapperProps {
  currentPoints: number;
  maxPoints: number;
  pointsLabel?: string;
  nextLevelLabel?: string;
  ariaLabel?: string;
  variant?: 'red' | 'green';
  hideWhenComplete?: boolean;
  className?: string;
}

export const ProgressBarWrapper: React.FC<ProgressBarWrapperProps> = ({
  currentPoints,
  maxPoints,
  pointsLabel = 'points',
  nextLevelLabel = 'Next level',
  ariaLabel = 'Progress',
  variant = 'red',
  hideWhenComplete = true,
  className,
}) => {
  if (hideWhenComplete && currentPoints >= maxPoints) {
    return null;
  }

  return (
    <div className={cn('w-full py-4', className)} aria-label={ariaLabel}>
      <ProgressBar currentPoints={currentPoints} maxPoints={maxPoints} variant={variant} />
      <div className="flex justify-between items-center pt-1 text-xs text-velux-black">
        <p className="text-left">
          {currentPoints} / {maxPoints} {pointsLabel}
        </p>
        <p className="text-right">{nextLevelLabel}</p>
      </div>
    </div>
  );
};
